/* eslint-disable no-unused-vars */
import React from 'react';
import Navbarsection from '../views/Home/Navbarsection';
import Footersection from '../views/Home/Footersection';
import Newupdates from '../Slides/Newupdates';

const Newlatestupdates = () => {
    return (
       <>
       <Navbarsection/>
<Newupdates/>
       <Footersection/>
       </>
    );
}

export default Newlatestupdates;
